"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Rocket = function Rocket(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "rocket",
    size: size
  }, _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M1.4 5.15c.2.2.2.5 0 .7l-.3.3a.5.5 0 01.8.58l.22-.22a.5.5 0 01.7.71l-.35.35a.5.5 0 01-.8-.58l-.57.57a.5.5 0 11-.7-.7l.65-.65a.5.5 0 11-.7-.71l.35-.35c.2-.2.51-.2.7 0zm3.52-2.43l.35.35-.53.89-.7-.71.88-.53z"
  }), _react["default"].createElement("path", {
    fill: color,
    d: "M6.69 2.37c.34.34.43.83.21 1.17L5.08 6.43c-.29.44-.96.44-1.4 0l-.06-.05a.5.5 0 01-.66-.67l-.04-.04A.5.5 0 012.25 5l-.04-.04a.5.5 0 01-.66-.66l.01.01c-.44-.44-.44-1.11 0-1.4l2.9-1.82c.33-.21.82-.13 1.16.2l-.21-.2a.25.25 0 01.11-.42l2-.5a.25.25 0 01.3.3l-.5 2a.25.25 0 01-.41.11l-.22-.21zm-1.65-.48L2.15 3.72l2.12 2.12L6.1 2.96 5.04 1.89z"
  }));
};

Rocket.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = Rocket;
exports["default"] = _default;